import { Box, BoxProps, ColorOptions, Icon, TextInput } from '@jfs/ui-new'
import { FC, useEffect, useRef } from 'react'
import { TextInput as RNTextInput } from 'react-native'
import { Colors } from '../../../util/util'

export interface SearchBarProps {
  onChange: (text: string) => void
  placeholder?: string
  value?: string
  hide?: boolean
  autoFocus?: boolean
  theme?: any
  fontFamily?: any
}

const styles = {
  container: (theme: any) =>
  ({
    flexDirection: 'row',
    paddingHorizontal: 8,
    borderWidth: 1,
    borderColor: '#B5B5B5' as ColorOptions,
    alignItems: 'center',
    height: 45,
    width: '100%',
    borderRadius: 8,
    backgroundColor: theme ? (theme?.bodyBgColor as ColorOptions) : 'BACKGROUND',
    underlayColor: theme ? (theme?.bodyBgColor as ColorOptions) : 'WHITE',
  } as BoxProps),
}

export const SearchBar: FC = ({ ...props }: SearchBarProps) => {
  const { placeholder = 'Search', value, hide, autoFocus, theme } = props
  const textInputRef = useRef<RNTextInput>(null)
  useEffect(() => {
    if (autoFocus) {
      setTimeout(() => {
        if (textInputRef.current) {
          textInputRef.current.focus()
        }
      }, 100)
    }
  }, [autoFocus])

  if (hide) {
    return null
  }

  const handleChange = (text: string) => {
    props?.onChange(text)
  }
  const leftComponent = <Icon id="SEARCH" size={20} color={'#B5B5B5' as ColorOptions} />
  const containerOnPress = () => {
    if (textInputRef.current) {
      textInputRef.current.focus()
    }
  }

  return (
    <Box {...styles.container(theme)} onPress={containerOnPress} testID="searchBarBox">
      <TextInput
        showBottomLine={false}
        //rightComponent={leftComponent}
        leftComponent={leftComponent}
        placeholder={placeholder}
        type="h2"
        onChangeText={handleChange}
        autoCorrect={false}
        autoCompleteType="name"
        autoCapitalize="none"
        value={value}
        innerRef={textInputRef}
        color={theme?.bodyTextColor as ColorOptions}
        placeholderTextColor={'PRIMARY_GREY'}
        fontFamily={'JioType-Medium'}
        fontSize={14}
        selectionColor={Colors.PRIMARY}
        testID="search"
        textAlign={'left'}
      />
    </Box>
  )
}
